module.exports = __webpack_public_path__ + "src/assets/games/19/233.jpg";